require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/core-js/library/fn/object/assign.js
// module id = +drv
// module chunks = 6